import React from "react";
import styled from "styled-components";

export default function ScoreRulePrevBox(props) {
  const { scoreRule, scoreRuleIndex } = props;

  // EMOM, TABATA 같은 라운드 반복 컴포넌트 만들기 //
  function decideRepeatComponent() {
    let round = scoreRule.round === '' ? 1 : scoreRule.round;
    let roundList = [];

    for (let i = 0; i < round; i++) {
      roundList.push('00');
    }

    return (
      <TotalRoundRepsInputWrapper>
        {
          roundList.map((data, index) => (
            <RoundRepsInputWrapper key={index}>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(index + 1) + 'R'}</Text>
              <RoundRepsInputView>
                <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>{data}</Text>
              </RoundRepsInputView>
            </RoundRepsInputWrapper>
          ))
        }
      </TotalRoundRepsInputWrapper>
    )
  }

  // Custom 점수 기록 방식 정리 //
  function decideCustomScoreStandard() {
    if (scoreRule.scoreKeyword === 'Not Scored') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>점수 없음</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>점수 없음</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Peek Watt') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>피크 와트</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Watts</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Max Speed') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>

            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>최고 속도</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Speed</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Time') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>

            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'시간 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <TotalInputWrapper>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Min</Text>
            </InputView>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Sec</Text>
            </InputView>
          </TotalInputWrapper>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Reps') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'렙수 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Round + Reps') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'라운드 + 렙수 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <TotalInputWrapper>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>R</Text>
            </InputView>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
            </InputView>
          </TotalInputWrapper>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Distance') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'거리 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>m</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Weight') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'무게 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>lbs</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.scoreKeyword === 'Point') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Circle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'포인트 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Point</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
  }


  // TieBreak //
  // EMOM, TABATA 같은 라운드 반복 컴포넌트 만들기 //
  function decideTieBreakRepeatComponent() {
    let round = scoreRule.tieBreakRound === '' ? 1 : scoreRule.tieBreakRound;
    let roundList = [];

    for (let i = 0; i < round; i++) {
      roundList.push('00');
    }

    return (
      <TotalRoundRepsInputWrapper>
        {
          roundList.map((data, index) => (
            <RoundRepsInputWrapper key={index}>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(index + 1) + 'R'}</Text>
              <RoundRepsInputView>
                <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>{data}</Text>
              </RoundRepsInputView>
            </RoundRepsInputWrapper>
          ))
        }
      </TotalRoundRepsInputWrapper>
    )
  }

  // Custom 점수 기록 방식 정리 //
  function decideCustomTieBreakScoreStandard() {
    if (scoreRule.tieBreakscoreKeyword === 'Not Scored') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>점수 없음</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>점수 없음</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Peek Watt') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>피크 와트</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Watts</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Max Speed') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>

            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>최고 속도</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Speed</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Time') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>

            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'시간 - ' + (scoreRule.tieBreakScorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <TotalInputWrapper>

            <SmallInputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Min</Text>
            </SmallInputView>
            <SmallInputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Sec</Text>
            </SmallInputView>
            <SmallInputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Ms</Text>
            </SmallInputView>
          </TotalInputWrapper>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Reps') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'렙수 - ' + (scoreRule.tieBreakScorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Round + Reps') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'라운드 + 렙수 - ' + (scoreRule.tieBreakScorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <TotalInputWrapper>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>R</Text>
            </InputView>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
            </InputView>
          </TotalInputWrapper>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Distance') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'거리 - ' + (scoreRule.tieBreakScorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.tieBreakCustomText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>m</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Weight') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'무게 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>lbs</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
    else if (scoreRule.tieBreakScoreKeyword === 'Point') {
      return (
        <TagStandardBox>
          <CustomTextTitleWrapper>
            <ColumnTextWrapper>
              <Triangle />
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{(scoreRuleIndex + 1) + '차 Custom 점수 기록 방식'}</Text>
            </ColumnTextWrapper>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{'포인트 - ' + (scoreRule.scorePriority === 'Heighter' ? '높을 수록' : '낮을 수록')}</Text>
          </CustomTextTitleWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>{scoreRule.customText}</Text>
          <LongInputView>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
            <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Point</Text>
          </LongInputView>
        </TagStandardBox>
      )
    }
  }
  //  TieBreak //

  return (
    <RecordStandardBoxWrapper>
      {
        scoreRule.tag === 'ForTime' &&
        <TagStandardBox>
          <ColumnTextWrapper>
            <Circle />
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>FORTIME 점수 기록 방식</Text>
          </ColumnTextWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>동작을 타임캡 안에 성공했을 경우</Text>
          <TotalInputWrapper>
            <SmallInputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Min</Text>
            </SmallInputView>
            <SmallInputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Sec</Text>
            </SmallInputView>
            <SmallInputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Ms</Text>
            </SmallInputView>
          </TotalInputWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>동작을 타임캡 안에 성공 못했을 경우 (끝낸 라운드+랩수를 알려주세요)</Text>
          <TotalInputWrapper>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>R</Text>
            </InputView>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
            </InputView>
          </TotalInputWrapper>
        </TagStandardBox>
      }
      {
        scoreRule.tag === 'AMRAP' &&
        <TagStandardBox>
          <ColumnTextWrapper>
            <Circle />
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>AMRAP 점수 기록 방식</Text>
          </ColumnTextWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>몇 라운드, 랩 수를 완벽하게 하셨나요?</Text>
          <TotalInputWrapper>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>R</Text>
            </InputView>
            <InputView>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
              <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
            </InputView>
          </TotalInputWrapper>
        </TagStandardBox>
      }
      {
        (scoreRule.tag === 'EMOM' || scoreRule.tag === 'TABATA') &&
        <TagStandardBox>

          <ColumnTextWrapper>
            <Circle />
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{scoreRule.tag} 점수 기록 방식</Text>
          </ColumnTextWrapper>
          <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>라운드별, 성공한 랩 수를 적어주세요</Text>
          {decideRepeatComponent()}
        </TagStandardBox>
      }
      {
        scoreRule.tag === 'Custom' && decideCustomScoreStandard()
      }
      {
        scoreRule.isUseTieBreak &&
        <TieBreakRecordStandardBoxWrapper>
          {
            scoreRule.tieBreakTag === 'ForTime' &&
            <TagStandardBox>
              <ColumnTextWrapper>
                <Triangle />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>FORTIME 점수 기록 방식</Text>
              </ColumnTextWrapper>
              <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>동작을 타임캡 안에 성공했을 경우</Text>
              <TotalInputWrapper>
                <SmallInputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Min</Text>
                </SmallInputView>
                <SmallInputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Sec</Text>
                </SmallInputView>
                <SmallInputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Ms</Text>
                </SmallInputView>
              </TotalInputWrapper>
              <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>동작을 타임캡 안에 성공 못했을 경우 (끝낸 라운드+랩수를 알려주세요)</Text>
              <TotalInputWrapper>
                <InputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>R</Text>
                </InputView>
                <InputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
                </InputView>
              </TotalInputWrapper>
            </TagStandardBox>
          }
          {
            scoreRule.tieBreakTag === 'AMRAP' &&
            <TagStandardBox>
              <ColumnTextWrapper>
                <Triangle />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>AMRAP 점수 기록 방식</Text>
              </ColumnTextWrapper>
              <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>몇 라운드, 랩 수를 완벽하게 하셨나요?</Text>
              <TotalInputWrapper>
                <InputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>R</Text>
                </InputView>
                <InputView>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>00</Text>
                  <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' hover='default'>Rep</Text>
                </InputView>
              </TotalInputWrapper>
            </TagStandardBox>
          }
          {
            (scoreRule.tieBreakTag === 'EMOM' || scoreRule.tieBreakTag === 'TABATA') &&
            <TagStandardBox>
              <ColumnTextWrapper>
                <Triangle />
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' hover='default'>{scoreRule.tieBreakTag} 점수 기록 방식</Text>
              </ColumnTextWrapper>
              <Text style={{ marginTop: '10px' }} fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' hover='default'>라운드별, 성공한 랩 수를 적어주세요</Text>
              {decideTieBreakRepeatComponent()}
            </TagStandardBox>
          }
          {
            scoreRule.tieBreakTag === 'Custom' && decideCustomTieBreakScoreStandard()
          }
        </TieBreakRecordStandardBoxWrapper>
      }
    </RecordStandardBoxWrapper>
  )
}

const RecordStandardBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 0px;

  width: 100%;
`;

const TieBreakRecordStandardBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 20px;

  width: 100%;
`;

const TagStandardBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(100% - 30px);
`;

const TotalInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  margin-top: 8px;

  width: 100%;
`;

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 15px;
  margin-top: 8px;

  width: calc(49% - 32px);
  height: 34px;

  border: 1px solid #CBCBCB;
  border-radius: 30px;
  background-color: #2F2F32;
`;

const SmallInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 15px;
  margin-top: 8px;

  width: calc(32% - 32px);
  height: 34px;

  border: 1px solid #CBCBCB;
  border-radius: 30px;
  background-color: #2F2F32;
`;

const LongInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 15px;
  margin-top: 8px;

  width: calc(100% - 32px);
  height: 34px;

  border: 1px solid #CBCBCB;
  border-radius: 30px;
  background-color: #2F2F32;
`;

const TotalRoundRepsInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  flex-wrap: wrap;

  margin-top: 8px;

  width: 100%;

  gap: 8px;
`;

const RoundRepsInputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 8px;

  width: 13%;
`;

const RoundRepsInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 15px;
  margin-top: 4px;

  // width: calc(13% - 32px);
  width: calc(100% - 32px);
  height: 34px;

  border: 1px solid #CBCBCB;
  border-radius: 10px;
  background-color: #2F2F32;
`;

const CustomTextTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;

  gap: 10px
`;

const ColumnTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const Circle = styled.div`
  width: 10px;
  height: 10px;

  border-radius: 10px;
  background-color: #6DD49E;
`;

const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 8px solid #6DD49E;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;